import TransactionsContent from '../transactions/transactions-content'

// agent_purchase is the same for buy and sell

const PublicProfileTransactionsSection = ({ userId }: { userId: number }) => {
  return (
    <div className="flex w-full flex-col gap-4">
      <div className="flex w-full flex-col gap-2">
        <TransactionsContent userId={userId} />
      </div>
    </div>
  )
}

export default PublicProfileTransactionsSection
